
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/post",
      function () {
        return require("private-next-pages/post/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/post"])
      });
    }
  